import { useEffect, useRef, useState } from "react";
import TitleGroup from "../../FontTitle/TitleGroup/TitleGroup";
import VoiceConfig from "../VoiceConfig/VoiceConfig";
import LineFontConfig from "../VoiceConfig/LineFontConfig/LineFontConfig";
import { observer } from "mobx-react";
import useGlobalCaption from "@/useStore/mixCutDetail/useGlobalCaption";
import {
  editorValueType,
  formatPreviewTimeSeconds,
} from "../VoiceLine/VoiceLine";
import MyEditor from "@/components/business/MyEditor";
import SmartSearch from "@/components/business/SmartSearch";
import Intelligent from "@/components/business/Intelligent";
import { Checkbox, Message } from "@arco-design/web-react";
import aiLineImg from "@/assets/cut-mix-detail/ai-text.png";
import clockImg from "@/assets/cut-mix-detail/clock_blue.png";
import lineImg from "@/assets/cut-mix-detail/color_sound.png";
import captionPlayerImg from "@/assets/cut-mix-detail/caption-playing.gif";
import loadingSvg from "@/assets/create-space/loading.svg";
import seo_edit from "@/assets/cut-mix-detail/seo-edit.png";
import "./GlobalCaption.less";
import {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../UIComponents/VideoConfigCard/VideoConfigCard";
import usePreviewConfig from "@/useStore/preview/usePreview";
import useAudioPlayer from "@/requestHooks/mixCutDetail/useAudioPlayer";
import { useEditorHelper } from "@/components/business/MyEditor/helper";
import clearBlue from "@/assets/cut-mix-detail/clear_blue.png";
import clock from "@/assets/cut-mix-detail/clock_#ccc.png";
import { estimateDuration } from "@/utils/perm";
import { timer } from "@/assets/workbenchimage";
import { checkLanguage } from "@/utils/judgment";
import useClickOutside from "@/hooks/useClickOutside";
import KeyWordsDrawer from "../../Components/KeyWordsDrawer/index";
import { ICaption } from "@/stores/mixCutDetailStore/type/caption";
import { initCaptionItem } from "@/stores/mixCutDetailStore/init";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import ConfigStore from "@/stores/mixedConfig";
import useMixCutDetailSave from "@/useStore/mixCutDetail/useMixCutDetailSave";

// 过滤空 listItem 的工具函数
function filterEmptyListItems(contentJson: any[]) {
  return contentJson.filter((item) => {
    if (
      item.type === "listItem" &&
      Array.isArray(item.content) &&
      item.content.length === 1 &&
      item.content[0].type === "paragraph" &&
      Array.isArray(item.content[0].content) &&
      item.content[0].content.length === 1 &&
      item.content[0].content[0].type === "text" &&
      item.content[0].content[0].text === ""
    ) {
      return false;
    }
    return true;
  });
}

const initEditorClearValue: editorValueType[] = [
  {
    type: "paragraph",
    content: [
      {
        type: "text",
        text: "",
      },
    ],
  },
];

export const toStrGetEditorValueType = (strList: string[]) => {
  if (strList && strList.length > 0) {
    return [
      ...strList.map((item) => ({
        type: "paragraph",
        content: [
          {
            type: "text",
            text: item,
          },
        ],
      })),
    ];
  } else {
    return initEditorClearValue;
  }
};

const GlobalCaption = observer((props) => {
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { sensitiveData } = props;
  const {
    globalCaptions,
    handleDeleteGlobalCaptionItem,
    handleAddGlobalCaptions,
    handleGlobalCationsChange,
  } = useGlobalCaption();
  const {
    isPlaying,
    stopAudio,
    playAudio,
    loading: isLoading,
  } = useAudioPlayer();
  const { handleClipIdChange, clipId } = usePreviewConfig();
  const { handlePreviewCaptionChange } = usePreviewConfig();
  const [activeIndex, setActiveIndex] = useState(0);
  const [aiSearchState, setAiSearchState] = useState(false);
  const [intelligenceState, setIntelligenceState] = useState(false);
  const [titleIntellIgenceValue, setTitleTntellIgenceValue] = useState("");
  const [titleIntellIgenceType, setTitleTntellIgenceType] = useState("改写");
  const [isIntelligenceTypo, setIsIntelligenceTypo] = useState(true);
  const [selector, setSelector] = useState(1);
  // smart所用
  const [smartValue, setSmartValue] = useState("");
  const [smartStatus, setSmartStatus] = useState("");
  const [sendSmartStatus, setSendSmartStatus] = useState("");
  const [itelligentIsExecution, setItelligentIsExecution] = useState(true);

  // 编辑器光标位置
  const [selectInfo, setSelectInfo] = useState({
    index: -1,
    range: {
      from: -1,
      to: -1,
    },
  });
  const [editLength, setEditLength] = useState<number>(0);
  const editorRef = useRef<any>(null);
  const aiSearchRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const getTitleGroup = () => {
    return globalCaptions.map((item, index) => {
      return {
        title: "台词组" + (index + 1),
        value: item.id,
      };
    });
  };

  const calculatorCaptionTime = () => {
    const caption = (globalCaptions || [])[activeIndex];
    const time = estimateDuration(
      caption.content,
      (caption?.voice_setting?.default_speed_rate || 20) / 100,
      true,
      caption?.voice_setting?.lang == "en"
    );
    return (time || 0).toFixed(0);
  };

  const handleClickInterlligent = (opt) => {
    const edit = editorRef.current.editor;
    const [helper] = useEditorHelper(edit);
    const { from, to } = helper.getSelectionSSML();
    switch (opt.type) {
      case "change":
        if (from === to) {
          edit.commands.focus("all");
          edit.commands.insertContent(opt.text);
        } else {
          edit.commands.insertContentAt(selectInfo.range, opt.text, {
            updateSelection: true,
            parseOptions: {
              preserveWhitespace: "full",
            },
          });
        }
        Message.success("替换成功");
        break;
      case "copy":
        navigator.clipboard.writeText(opt.text);
        Message.success("复制成功");
        break;
      case "splice":
        edit.commands.insertContentAt(selectInfo.range, opt.text, {
          updateSelection: true,
          parseOptions: {
            preserveWhitespace: "full",
          },
        });
        Message.success("添加成功");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const editor = editorRef.current.editor;
    const [helper] = useEditorHelper(editor);
    setSelectInfo({ ...selectInfo, range: helper.getSelectionSSML() });
  }, [activeIndex]);

  const toPlayStateGetImg = (index: number) => {
    if (isLoading === true)
      return (
        <img
          onClick={() => {
            stopAudio();
          }}
          src={loadingSvg}
          alt=""
        />
      );
    if (isPlaying === true)
      return (
        <img
          onClick={() => {
            stopAudio();
          }}
          src={captionPlayerImg}
          alt=""
        />
      );
    return (
      <img
        onClick={() => {
          handlePlayerCaption(index);
        }}
        src={lineImg}
        alt=""
      />
    );
  };

  const handlePlayerCaption = async (index: number) => {
    try {
      const [helper] = useEditorHelper(editorRef.current.editor);
      const item = globalCaptions[index];
      if (item.content.join(",").length > 0) {
        await playAudio(
          {
            line: helper.exportSSML(),
            speaker_id: item.voice_setting.speaker_id,
            speed_ratio: item.voice_setting.speed_ratio,
            volume_ratio: item.voice_setting.volume_ratio,
            pitch_ratio: item.voice_setting.pitch_ratio,
          },
          selector === 6 ? "custom" : "official"
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  useClickOutside({
    ref: aiSearchRef,
    handler: () => {
      setAiSearchState(false);
      setIntelligenceState(false);
      setItelligentIsExecution(true);
    },
    isActive: aiSearchState,
  });

  const handleKeywordsChange = (data, type) => {
    const regExp = new RegExp(/[,，.。;；:：?？!！………—、-]/, "g");
    const textArr = data.split(regExp);
    const _content_json = [];
    textArr.forEach((item) => {
      _content_json.push({
        type: "listItem",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: item,
              },
            ],
          },
        ],
      });
    });
    // 添加至新台词组
    if (type === "copy") {
      if (ConfigStore.global_settings.captions.length === 15) {
        Message.error("最多导入台词组15条");
        return false;
      }
      const newItem: ICaption = {
        ...initCaptionItem,
        id: Math.floor(Date.now() + Math.random() * 10000),
        content: textArr.map((text) => {
          return `<speak>${text}</speak>`;
        }),
        _preview: data.replaceAll(regExp, "\n\n\n\n"),
        _content_json: filterEmptyListItems(_content_json),
      };
      const gCaptions = mixCutDetailStore.getProjectGlobalCaptions();
      mixCutDetailStore.setProjectGlobalCaptions([...gCaptions, newItem]);
      ConfigStore.global_settings.captions = [...gCaptions, newItem];
      handleSaveMixCutDetailSave();
    } else {
      const gCaptions = mixCutDetailStore.getProjectGlobalCaptions();
      gCaptions[activeIndex].content = gCaptions[activeIndex].content.concat(
        textArr.map((text) => {
          return `<speak>${text}</speak>`;
        })
      );
      gCaptions[activeIndex]._content_json = (
        gCaptions[activeIndex]._content_json || []
      ).concat(filterEmptyListItems(_content_json));
      gCaptions[activeIndex]._preview =
        gCaptions[activeIndex]._preview +
        "\n\n\n\n" +
        data.replaceAll(regExp, "\n\n\n\n");
      mixCutDetailStore.setProjectGlobalCaptions(gCaptions);
      ConfigStore.global_settings.captions = gCaptions;
      handlePreviewCaptionChange(gCaptions[activeIndex]);
      handleSaveMixCutDetailSave();
    }
  };

  return (
    <div className="global-caption">
      <TitleGroup
        maxLength={15}
        titleCopy="添加台词组"
        style={{ marginTop: 12, marginBottom: 12 }}
        handleActiveIndexChange={(index) => {
          handlePreviewCaptionChange(globalCaptions[index]);
          setActiveIndex(index);
          stopAudio();
        }}
        active={activeIndex}
        data={getTitleGroup()}
        handleAddBtnClick={handleAddGlobalCaptions}
        isEdit={true}
        handleDeleteBtnClick={(e: number) => {
          if (globalCaptions.length === 1) {
            Message.error("必须保持有一个台词组！");
            return;
          }
          if (e === 0 && activeIndex === 0) {
            handlePreviewCaptionChange((globalCaptions || [])[1] || null);
            handleClipIdChange(null);
          }
          if (activeIndex === e) {
            setActiveIndex(0);
          }
          if (activeIndex > e) {
            setActiveIndex(activeIndex - 1);
          }

          handleDeleteGlobalCaptionItem(e);
        }}
      ></TitleGroup>
      <VideoConfigCardHeader
        headerLeft={
          <div className="caption-header">
            台词文案{toPlayStateGetImg(activeIndex)}
          </div>
        }
        headerRight={
          <>
            <Checkbox
              onChange={(e) => {
                const gCaptionItem = { ...globalCaptions[activeIndex] };
                gCaptionItem.text_setting.is_global = e;
                handleGlobalCationsChange(activeIndex, gCaptionItem);
              }}
              checked={
                (globalCaptions || [])[activeIndex]?.text_setting?.is_global
              }
            >
              <span
                style={{
                  fontSize: 12,
                  color: "#333333",
                }}
              >
                同步位置到全局
              </span>
            </Checkbox>
          </>
        }
      />
      <VideoConfigCardContainer style={{ padding: 10 }}>
        <div style={{ position: "relative" }} className="editor-wrapper">
          <MyEditor
            isFormat
            ref={(ref) => {
              editorRef.current = ref;
            }}
            content={
              (globalCaptions || [])[activeIndex]?._content_json &&
              (globalCaptions || [])[activeIndex]?._content_json?.length > 0
                ? (globalCaptions || [])[activeIndex]?._content_json
                : [
                    {
                      type: "listItem",
                      content: [
                        {
                          type: "paragraph",
                        },
                      ],
                    },
                  ]
            }
            placeholder={"请输入台词文案, shift+enter行内折行"}
            type={"caption"}
            forbid={sensitiveData}
            singleLine={100}
            limit={1000}
            resTextLength={setEditLength}
            limitPosition={{
              display: "none",
            }}
            handlefocus={() => {
              handleClipIdChange(globalCaptions[activeIndex].id);
            }}
            handleUpdate={(val) => {
              const data = (
                editorRef.current.editor.getJSON().content[0].content || []
              ).map((node) => {
                return `<speak>${editorRef.current.helper.formatNodeToSSML(node).replace(/\n\n/g, "")}</speak>`;
              });
              const newItem = { ...globalCaptions[activeIndex] };
              newItem.content = data;
              newItem._content_json = val;
              handleGlobalCationsChange(activeIndex, newItem);
              handlePreviewCaptionChange(newItem);
            }}
            selected={({ value, range }) => {
              setSmartValue(
                value ||
                  editorRef.current.editor
                    .getText()
                    .replace(/\n\n\n\n/g, "\n")
                    .slice(1)
              );
              setSelectInfo({
                index: -1,
                range,
              });
            }}
            selectInfo={selectInfo}
          />
          <div className="voice-container-bar" ref={aiSearchRef}>
            <img
              src={aiLineImg}
              alt=""
              className="ai-line"
              onClick={(e) => {
                e.stopPropagation();
                setAiSearchState(true);
              }}
            />
            <div
              className="insert-opeator"
              style={{ position: "relative", zIndex: 10, marginLeft: 6 }}
            >
              <div
                className="tags insert-stop"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  editorRef.current.addBreak({
                    time: "0.5s",
                  });
                }}
              >
                <img src={clockImg} alt="" />
                插入停顿
              </div>
              {aiSearchState ? (
                <SmartSearch
                  placeholder={"帮我写..."}
                  styles={{
                    marginLeft: "70px",
                    width: "468px",
                  }}
                  handelClickBtn={(value: string, type: string) => {
                    setSmartStatus(type);
                    setSendSmartStatus(value);
                    setAiSearchState(false);
                    setIntelligenceState(true);
                  }}
                  editValue={smartValue}
                  isEnd={itelligentIsExecution}
                  handleKeyDown={(event) => {
                    if (
                      event.key === "Escape" ||
                      event.keyCode === 27 ||
                      event.key === "Enter"
                    ) {
                      setAiSearchState(false);
                      setIntelligenceState(true);
                    }
                  }}
                />
              ) : (
                <></>
              )}
            </div>
            <div
              className="seo-box-wrapper"
              style={{ marginLeft: 6, cursor: "pointer" }}
              onClick={() => {
                setIsOpen(true);
              }}
            >
              <img src={seo_edit} alt="" />
              关键词
            </div>
            <div
              className="clear-box-wrapper"
              style={{ marginLeft: 6, cursor: "pointer" }}
              onClick={() => {
                const captionItem = { ...globalCaptions[activeIndex] };
                captionItem._preview = "";
                captionItem.content = [];
                captionItem._content_json = [
                  {
                    type: "listItem",
                    content: [
                      {
                        type: "paragraph",
                      },
                    ],
                  },
                ];
                handleGlobalCationsChange(activeIndex, captionItem);
                handlePreviewCaptionChange(captionItem);
              }}
            >
              <img src={clearBlue} alt="" />
              清空
            </div>
            <div className="preview-time">
              <div className="preview-info">
                <img src={timer} alt="" style={{ marginRight: 2 }} />
                {formatPreviewTimeSeconds(calculatorCaptionTime())}
              </div>
              &emsp;
              <div>{editLength}/1000</div>
            </div>
          </div>
        </div>
      </VideoConfigCardContainer>
      {intelligenceState ? (
        <Intelligent
          style={{
            width: "400px",
            position: "fixed",
            right: 0,
            bottom: 0,
            height: "calc(100vh - 85px)",
            zIndex: 1000,
            top: 73,
          }}
          defaultStatus={smartStatus}
          value={sendSmartStatus}
          isInExecution={setItelligentIsExecution}
          handleOnChange={(e) => {
            handleClickInterlligent(e);
          }}
          handleCloseBtnClick={() => {
            setSendSmartStatus("");
            setIntelligenceState(false);
            setAiSearchState(false);
          }}
        />
      ) : (
        <></>
      )}
      <VoiceConfig
        emitTimbreSelector={(e) => {
          setSelector(e);
        }}
        global={true}
        is_global={false}
        style={{ marginTop: 12 }}
        speedValue={
          (globalCaptions || [])[activeIndex]?.voice_setting.speed_ratio
        }
        pitchValue={
          (globalCaptions || [])[activeIndex]?.voice_setting.pitch_ratio
        }
        speekerId={
          (globalCaptions || [])[activeIndex]?.voice_setting.speaker_id
        }
        volume={(globalCaptions || [])[activeIndex]?.voice_setting.volume_ratio}
        handleSpeedValueChange={(e) => {
          const newItem = globalCaptions[activeIndex];
          newItem.voice_setting.speed_ratio = e;
          handleGlobalCationsChange(activeIndex, { ...newItem });
          handlePreviewCaptionChange(newItem);
        }}
        handlePitchValueChange={(e) => {
          const newItem = globalCaptions[activeIndex];
          newItem.voice_setting.pitch_ratio = e;
          handleGlobalCationsChange(activeIndex, { ...newItem });
          handlePreviewCaptionChange(newItem);
        }}
        handleSpeekerIdChange={(
          e,
          name,
          rate,
          platform,
          lang,
          gender,
          type
        ) => {
          const str = globalCaptions[activeIndex].content
            .map((item) => item.replace(/<\/?speak>/g, ""))
            .join("");
          if (str.length > 0 && !checkLanguage(lang, str) && selector !== 6) {
            Message.error("请选择与台词语言一致的配音选项");
            return;
          }
          const newItem = globalCaptions[activeIndex];
          newItem.voice_setting.speaker_id = e;
          newItem.voice_setting.speaker_name = name;
          newItem.voice_setting.default_speed_rate = rate;
          newItem.voice_setting.platform = platform;
          newItem.voice_setting.lang = lang;
          newItem.voice_setting.gender = gender;
          newItem.voice_setting.type = type;
          handleGlobalCationsChange(activeIndex, { ...newItem });
          handlePreviewCaptionChange(newItem);
        }}
        handleVolumeChange={(e) => {
          const newItem = globalCaptions[activeIndex];
          newItem.voice_setting.volume_ratio = e;
          handleGlobalCationsChange(activeIndex, { ...newItem });
          handlePreviewCaptionChange(newItem);
        }}
      />
      <LineFontConfig
        global={true}
        style={{ marginTop: 12 }}
        data={(globalCaptions || [])[activeIndex]?.text_setting}
        handleTextSettingChange={(e) => {
          const newItem = globalCaptions[activeIndex];
          console.log(e, "测试");
          newItem.text_setting = e;
          switch (e.alignment) {
            case "left":
              newItem.text_setting.x = 0;
              break;
            case "center":
              newItem.text_setting.x = 0.5;
              break;
            case "right":
              newItem.text_setting.x = 1;
              break;
          }
          handleGlobalCationsChange(activeIndex, { ...newItem });
          handlePreviewCaptionChange(newItem);
        }}
      />
      {isOpen && (
        <KeyWordsDrawer
          style={{
            width: "400px",
            position: "fixed",
            right: 0,
            bottom: 0,
            height: "calc(100vh - 85px)",
            zIndex: 1000,
            top: 73,
          }}
          emitChange={(data, type) => {
            handleKeywordsChange(data, type);
          }}
          keywords={ConfigStore.global_settings.keywords}
          keywordsId={ConfigStore.global_settings.keywords_id}
          handleCancel={() => {
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
});

export default GlobalCaption;
